import { LeadProfileSuggestionValue } from "model/lead-profile-suggestion";
import { LeadProfileSuggestionField } from "type/lead-profile-suggestion-field";
import {
	formatLeadTimeline,
	formatLeadPrice,
	formatLeadPreApproval,
	hasLeadTimeline,
} from "shared/lead-readiness-formatter";

const UNSET = "—";

/**
 * One side of a suggestion, formatted exactly as Lead Details formats the same field, or a dash
 * when the lead has no value for it yet.
 */
export const formatLeadProfileSuggestionValue = (
	field: LeadProfileSuggestionField,
	value: LeadProfileSuggestionValue
): string => {
	if (field.timeline) {
		if (!hasLeadTimeline(value.timelineEnd, value.justBrowsing)) {
			return UNSET;
		}
		return formatLeadTimeline(value.timelineStart, value.timelineEnd, value.justBrowsing);
	}
	if (field.price) {
		return value.price == null ? UNSET : formatLeadPrice(value.price);
	}
	if (value.preApproved == null) {
		return UNSET;
	}
	return formatLeadPreApproval(value.preApproved) || UNSET;
};
